/***************************************************************
8/2/2019
Alexander Self
solutions_table.js
- Displays a list of chemical solutions
***************************************************************/
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  chemicalList: PropTypes.array,
  solutions: PropTypes.array
};

const SolsTable = ({ solutions, chemicalList }) => {
  if (!solutions) return <span></span>;

  return (
    <table className="bordered highlight responsive-table centered">
      <thead>
        <tr>
          <th>Chemical</th>
          <th>Chemical %</th>
          <th>Dosage</th>
        </tr>
      </thead>
      <tbody>
        {
          solutions.map((s, i) => {
            let chem = chemicalList.find((c) => c.id === Number(s.chemId));
            return (
              <tr key={s.id}>
                <td>{ chem.name } - { chem.type }</td>
                <td>{ isNaN(s.percentageUsed) ? 0 : s.percentageUsed }%</td>
                <td>{ s.chemDosage }</td>
              </tr>
            )
          })
        }
      </tbody>
    </table>
  )

};

SolsTable.propTypes = propTypes;
export default SolsTable;



// WEBPACK FOOTER //
// ./src/cultivation/components/chem_app/chem_app_sol_table.js